import { useQuery } from "react-query";

import { navLinks } from "../data/navLinks";
import { getAllLinks } from "../utils/api";

const normalizeLinks = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    const match = raw.match(/\[[\s\S]*\]/);
    if (match) {
      try {
        const parsed = JSON.parse(match[0]);
        if (Array.isArray(parsed)) return parsed;
      } catch {
        /* fall through */
      }
    }
  }
  return navLinks;
};

const useLinks = () => {
  const { data, isLoading, isError, refetch } = useQuery(
    "allLinks",
    getAllLinks,
    { refetchOnWindowFocus: false }
  );

  return {
    data: normalizeLinks(data),
    isError,
    isLoading,
    refetch,
  };
};

export default useLinks;
